// Acceso a los respaldos bilingues de `shared/utils/translations` desde un
// componente o un hook, ya resueltos al idioma de la interfaz.
//
// Existe para que cada pantalla no repita el par "leer LangContext + normalizar":
// esa comparacion `startsWith("es")` estaba copiada en una veintena de archivos y
// era justo lo que se olvidaba, dejando el aviso siempre en espanol.
//
// El respaldo del almacenamiento cubre a quien monta antes de que LangContext
// tenga valor; `clearSessionData` conserva esa preferencia al cerrar sesion.

import { useContext } from "react";
import { LangContext } from "../../app/contexts/Contexts";
import {
  normalizeInterfaceLanguage,
  readStoredInterfaceLanguage,
} from "../../shared/utils/interfaceLanguage";
import { getAccountMessages } from "../../shared/utils/translations/accountMessages";
import { getPropertyMessages } from "../../shared/utils/translations/propertyMessages";
import { getSocialMessages } from "../../shared/utils/translations/socialMessages";
import { getLocationMessages } from "../../shared/utils/translations/locationMessages";
import {
  getIdentityMessages,
  getUploadCardMessages,
} from "../../shared/utils/translations/identityMessages";
import { getCouponMessages } from "../../shared/utils/translations/couponMessages";
import { getEventShareTexts } from "../../shared/utils/translations/eventShareTexts";

export const useInterfaceLanguage = () => {
  const { lang } = useContext(LangContext);
  return normalizeInterfaceLanguage(lang || readStoredInterfaceLanguage());
};

export const useAccountMessages = () => getAccountMessages(useInterfaceLanguage());
export const usePropertyMessages = () => getPropertyMessages(useInterfaceLanguage());
export const useSocialMessages = () => getSocialMessages(useInterfaceLanguage());
export const useLocationMessages = () => getLocationMessages(useInterfaceLanguage());
export const useIdentityMessages = () => getIdentityMessages(useInterfaceLanguage());
export const useCouponMessages = () => getCouponMessages(useInterfaceLanguage());
export const useEventShareTexts = () => getEventShareTexts(useInterfaceLanguage());

// UploadCard e IdentityUploadView leen sus textos con `t(clave)` usando los
// nombres de clave del esquema remoto, no camelCase: se les entrega la tabla tal
// cual para que el esquema siga ganando cuando publique esas claves.
export const useUploadCardMessages = () =>
  getUploadCardMessages(useInterfaceLanguage());
